import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FmAvatarComponent } from '@app/shared/components/fm-avatar/fm-avatar.component'
import type { CalendarDayAvailablePartner } from '../../../dashboard/components/calendar-day/calendar-day.component'
import { UserService } from '@app/core/_services/user.service'
import { take } from 'rxjs'
import { GroupInfo } from '@app/core/_models'
import { FmGroupAvatarComponent } from '@app/shared/components/fm-group-avatar/fm-group-avatar.component'
import { ButtonModule } from 'primeng/button'
import { FmSendProfileToDynamicPanelDirective } from '@app/core/_directives/fm-send-profile-to-dynamic-panel.directive'
import { AmbassadorSessionsBadgeComponent } from '@app/shared/components/ambassador-sessions-badge/ambassador-sessions-badge.component'
import { HostBadgeComponent } from '@app/shared/components/host-badge/host-badge.component'
import { FeatureCheckService } from '@app/core/_services/feature-check.service'

@Component({
    selector: 'fm-profile-preview',
    imports: [
        FmAvatarComponent,
        FmGroupAvatarComponent,
        ButtonModule,
        FmSendProfileToDynamicPanelDirective,
        AmbassadorSessionsBadgeComponent,
        HostBadgeComponent,
    ],
    templateUrl: './profile-preview.component.html',
    styleUrl: './profile-preview.component.scss',
})
export class ProfilePreviewComponent {
    @Input() data: CalendarDayAvailablePartner
    @Input() showCloseButton: boolean
    @Output() onViewProfileSelected = new EventEmitter<Event>()
    @Output() onClosePopover = new EventEmitter<Event>()

    constructor(
        private userService: UserService,
        public featureCheckService: FeatureCheckService,
    ) {}

    public sharedGroups: GroupInfo[] = []

    ngOnInit(): void {
        const groups: GroupInfo[] = []
        this.userService.currentUser.pipe(take(1)).subscribe((currentUser) => {
            for (const group of this.data.partner?.groups) {
                const sharedGroup = currentUser.group.find(
                    (element) => element.groupId === group.groupId,
                )
                if (sharedGroup) {
                    groups.push(sharedGroup)
                }
            }
            this.sharedGroups = [...groups]
        })
    }

    ngOnChanges() {}
}
